module.exports = __webpack_public_path__ + "img/test3.cdc38f25.jpg";